import { useCore } from "@/core/core";
import { watchEffect } from "vue";

export function useBold() {
    const { config } = useCore();

    watchEffect(() => {
        window.document.body.style.fontWeight = config.fontWeight.toString();
        // window.document.body.style.fontWeight = config.fontBold ? "500" : "400"
    })
}